<div class="p-4">
  <h2 mat-dialog-title class="font-white mb-3">Confirm Registration</h2>
  <div mat-dialog-content>
    <p class="font-gray mb-3 fs-14">Are you sure you want to register the following students?</p>
    <ul class="list-group custom-list-scroll" style="max-height: 400px; overflow-y: auto">
      <li class="list-group-item bg-card-secondary font-white border-0 mb-2 rounded-3 px-3 py-2" *ngFor="let student of data.students">
        <div class="d-flex flex-column">
          <span class="fw-bold">{{ student.FirstName }} {{ student.MiddleName }} {{ student.LastName }}</span>
          <span class="fs-12 font-gray">{{ student.CenterName || "" }} • {{ student.Gender || "-" }}</span>
        </div>
      </li>
    </ul>
  </div>
  <div mat-dialog-actions align="end" class="gap-2 mt-4">
    <button class="close-btn px-4 py-2" (click)="onClose()">Close</button>
    <button class="add-btn px-4 py-2" (click)="onSubmit()">Submit</button>
  </div>
</div>
